<template>
  <section class="positions">
    <el-form>
      <el-form-item :span="8">
        <el-input
          placeholder="Search..."
          v-model="formData.inputValue"
        ></el-input>
      </el-form-item>
      <el-form-item :span="6">
        <el-select
          placeholder="All Departments"
          v-model="formData.department"
        >
          <el-option
            v-for="item in positionOption"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :span="6">
        <el-select
          placeholder="All Locations"
          v-model="formData.location"
        >
          <el-option
            v-for="item in locOption"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      :data="tabledata"
      :border="false"
      :show-header="false"
      @row-click="toPosition"
    >
      <el-table-column
        prop="position"
        width="500px"
      ></el-table-column>
      <el-table-column prop="department"></el-table-column>
      <el-table-column prop="location"></el-table-column>
      <el-table-column width="50px">
        <i class="el-icon-plus"></i>
      </el-table-column>
    </el-table>
  </section>
</template>

<script>
export default {
  name: 'positions',
  components: {},
  props: {
    locValue: String
  },
  data() {
    return {
      positionOption: [],
      locOption: [],
      formData: {},
      tabledata: []
    }
  },
  created() {
    this.getOption()
    this.onQuery()
  },
  mounted() { },
  methods: {
    getOption() {
      this.positionOption = [
        { label: '所有部门', value: 'ALL' },
        { label: '人力资源', value: '1020' },
        { label: '安全', value: '1100' },
        { label: '计数支持', value: '1095' },
        { label: '操作', value: '1071' },
        { label: '工程', value: '1070' },
        { label: '设备', value: '1023' },
        { label: '解决方案', value: '1021' },
        { label: '专业服务', value: '996' },
        { label: '技术运营', value: '1019' },
        { label: '研发', value: '1017' },
        { label: '付款与欺诈', value: '1016' },
        { label: '金融', value: '1015' },
        { label: '客服', value: '1014' },
        { label: '产品', value: '1005' },
        { label: '销售', value: '1001' }
      ]
      this.locOption = [
        { value: 'ALL', label: '所有地点' },
        { value: '998', label: '英国，伦敦' },
        { value: '1004', label: '爱尔兰， 都柏林' },
        { value: '1007', label: '美国， 亚特兰大， GA' },
        { value: '1008', label: '香港' },
        { value: '1009', label: '韩国，首尔' },
        { value: '1010', label: '日本， 东京' },
        { value: '1011', label: '美国， 新泽西州霍博肯' },
        { value: '1024', label: '美国， 纽约州， NY' },
        { value: '1025', label: '美国， 洛杉矶， CA' },
        { value: '1026', label: '以色列， Petah Tikva' },
        { value: '1069', label: '澳大利亚， 墨尔本' },
        { value: '1073', label: '法国， 巴黎' },
        { value: '1080', label: '罗马尼亚， 布加勒斯特' },
        { value: '1094', label: '德国， 柏林' },
        { value: '1099', label: '瑞典， 斯德哥尔摩' }
      ]
    },
    onQuery() {
      this.tabledata = [
        {
          position: '税务运营分析师',
          department: '操作',
          location: '以色列， Petah Tikva'
        },
        {
          position: '人才招聘团队负责人',
          department: '人力资源',
          location: '以色列， Petah Tikva'
        },
        {
          position: '系统架构师',
          department: '研发',
          location: '罗马尼亚， 布加勒斯特'
        },
        {
          position: '战略客户客户成功经理',
          department: '销售',
          location: '人力资源'
        },
        {
          position: '解决方案工程师 （合作伙伴）',
          department: '解决方案',
          location: '人力资源'
        },
        {
          position: '解决方案工程师',
          department: '专业服务',
          location: '美国， 纽约州， NY'
        },
        {
          position: '解决方案工程师',
          department: '解决方案',
          location: '美国， 纽约州， NY'
        },
        {
          position: '软件工程师',
          department: '研发',
          location: '罗马尼亚， 布加勒斯特'
        },
        {
          position: '软件工程师',
          department: '研发',
          location: '以色列， Petah Tikva'
        },
        {
          position: '软件架构师',
          department: '研发',
          location: '罗马尼亚， 布加勒斯特'
        },
        {
          position: '高级软件工程师',
          department: '工程',
          location: '美国， 新泽西州霍博肯'
        },
        {
          position: '高级软件工程师',
          department: '工程',
          location: '安全'
        },
        {
          position: '高级软件工程师',
          department: '工程',
          location: '安全'
        },
        {
          position: '高级产品经理 - 数据',
          department: '金融',
          location: '以色列， Petah Tikva'
        }
      ]
    },
    toPosition(e) {
      console.log(e)
    }
  }
}
</script>

<style scoped lang="less">
.positions {
  width: 1140px;
  margin: 0 auto 100px;
  .el-form {
    display: flex;
    justify-content: space-between;
    margin: 70px 0 10px;
    .el-form-item {
      flex: 2;
    }
    .el-form-item:nth-child(1) {
      flex: 3;
    }
    .el-input {
      width: 90%;
      ::v-deep input {
        border-left: none;
        border-right: none;
        border-top: none;
        border-radius: 0;
        &::placeholder {
          font-size: 20px;
        }
        &:focus {
          // border: 2px #000 solid !important;
          // border-radius: 3px;
          border-bottom: 2px #000 solid;
        }
      }
    }
    .el-select {
      width: 90%;
      ::v-deep input {
        border-radius: 0;
        border: none;
        &::placeholder {
          font-size: 20px;
        }
      }
    }
  }
  .el-table {
    ::v-deep .el-table__row {
      font-family: "Poppins", sans-serif;
      font-size: 20px;
      height: 72px;
      .el-table__cell {
        cursor: pointer;
        border-top: none;
        .el-icon-plus {
          font-weight: 600;
          color: #2f5ad9;
          font-size: 28px;
        }
      }
      .el-table_1_column_1 {
        color: #2a2c2f;
        font-weight: 600;
      }
      .el-table_1_column_2 {
        color: #2f5ad9;
      }
      .el-table_1_column_3 {
        color: #2a2c2f;
      }
    }
  }
}
</style>
